import { LifeStageDatePrecisionEnum } from "@/Common/Models/LifeStageDatePrecisionEnum";

class MedicalHistoryMentalHealthAndSubstanceUse {
    public AnxietyPast?: boolean;
    public AnxietyPresent?: boolean;
    public GeneralizedAnxietyDisorder2Score: number;
    public DepressionPast?: boolean;
    public DepressionPresent?: boolean;
    public PatientHealthQuestionnaire2Score: number;
    public EatingDisorder?: boolean;
    public Bipolar?: boolean;
    public Schizophrenia?: boolean;
    public Other?: boolean;
    public SmokedCigaretteWithinPast6Months?: boolean;
    public NumberOfCigarettesPerDay?: number;
    public HasEverDrunkAlcohol?: boolean;
    public LastDrinkDate?: Date;
    public LastDrinkDatePrecision: LifeStageDatePrecisionEnum;
    public CurrentDrinksPerWeek?: number;
    public TaceScreeningScore?: number;
    public Marijuana?: boolean;
    public NonPrescribedSubstancesAndDrugs?: boolean;

    constructor(fields?: Partial<MedicalHistoryMentalHealthAndSubstanceUse>) {
        Object.assign(this, fields);
    }

    public setEmptyFieldsAsNo(): void {
        this.AnxietyPast = this.AnxietyPast || false;
        this.AnxietyPresent = this.AnxietyPresent || false;
        this.DepressionPast = this.DepressionPast || false;
        this.DepressionPresent = this.DepressionPresent || false;
        this.EatingDisorder = this.EatingDisorder || false;
        this.Bipolar = this.Bipolar || false;
        this.Schizophrenia = this.Schizophrenia || false;
        this.Other = this.Other || false;
        this.SmokedCigaretteWithinPast6Months = this.SmokedCigaretteWithinPast6Months || false;
        this.HasEverDrunkAlcohol = this.HasEverDrunkAlcohol || false;
        this.Marijuana = this.Marijuana || false;
        this.NonPrescribedSubstancesAndDrugs = this.NonPrescribedSubstancesAndDrugs || false;
    }
}

export { MedicalHistoryMentalHealthAndSubstanceUse };
